import { useParams } from 'react-router-dom';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { Page } from '../../../../components/page/Page';
import { useContent } from '../../hooks/useContent';
import { ContentAiModule } from '../../index';
import { ContentWizard } from './ContentWizard';
import { ContentAiFragmentOriginInfo } from './fragment-info/ContentAiFragmentOriginInfo';
import { ContentAiFragmentInfo } from './fragment-info/types';
import './style.css';

export function ContentPage() {
  const { contentId } = useParams<{ contentId: string }>();
  const result = useContent(contentId!);

  return (
    <QueryView query={result}>
      {(data) => {
        const fragment = data.source.data.fragment! as ContentAiFragmentInfo;

        return (
          <Page htmlTitle={fragment.title}>
            <Page.Header
              breadcrumbs={
                <Page.ModuleBreadcrumbs
                  module={ContentAiModule}
                  items={[{ content: fragment.title, active: true }]}
                />
              }
            />
            <Page.Content className="pt-2">
              <ContentAiFragmentOriginInfo content={result.data!} fragment={fragment} />
              <ContentWizard content={result.data!} />
            </Page.Content>
          </Page>
        );
      }}
    </QueryView>
  );
}
